module.exports = __webpack_public_path__ + "img/portfolio-big-05.31e55c3e.png";